export const wrapModelObjectWithSearchOption = object => ({
  label: object.name,
  value: object.id,
  data: object,
});